// extracted by mini-css-extract-plugin
export default {"tableColumn":"AssociatedLocation_tableColumn__s8iLf"};